import useWidth from './useWidth';

export const useDeviceWidth = () => {
  const deviceWidth = useWidth();
  return {
    isMobile: deviceWidth <= 600,
    isTab: deviceWidth > 600 && deviceWidth <= 768,
    isLargeScreen: deviceWidth >= 800
  };
};
